import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { destroyCurrentSession } from '../../../entities/auth/session/actions';
import { setRedirectUrl } from '../../../entities/redirect/actions';
import { IThunkDispatch } from '../../../store/middleware';

export const Logout: React.FC = () => {
	const dispatch = useDispatch<IThunkDispatch>();
	const navigate = useNavigate();
	React.useEffect(() => {
		dispatch(destroyCurrentSession());
		dispatch(setRedirectUrl('/'));
		navigate('/');
	}, []);
	return null;
};
